(function(){
  var ENDPOINT = 'https://dashboard.prsprsystem.com/api/ingest/offer-events';
  var SESSION_KEY = 'prspr_offer_session_id';
  var trackedCardsViewed = false;
  function uuid(){
    if(window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'evt_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2);
  }
  function getSessionId(){
    try {
      var existing = localStorage.getItem(SESSION_KEY);
      if(existing) return existing;
      var created = 'sess_' + uuid();
      localStorage.setItem(SESSION_KEY, created);
      return created;
    } catch(_err) { return 'sess_' + uuid(); }
  }
  function pageSlug(){
    var slug = location.pathname.replace(/^\/+|\/+$/g, '').split('/').pop();
    return slug || 'index';
  }
  function attribution(){
    var p = new URLSearchParams(location.search);
    return {source:p.get('utm_source'),medium:p.get('utm_medium'),campaign:p.get('utm_campaign'),content:p.get('utm_content'),term:p.get('utm_term'),trybe:p.get('trybe')};
  }
  function text(el, selector){
    var node = selector ? el.querySelector(selector) : el;
    return ((node && node.textContent) || '').replace(/\s+/g, ' ').trim();
  }
  function safeHost(value){ try { return value ? new URL(value, location.href).host : null; } catch(_err) { return null; } }
  function safePath(value){ try { return value ? new URL(value, location.href).pathname : null; } catch(_err) { return null; } }
  function cardPayload(card){
    var url = card.getAttribute('data-checkout-href') || card.getAttribute('data-card-checkout-href') || card.getAttribute('href') || '';
    return {label:text(card,'.label'),qty:text(card,'.qty'),price:text(card,'.price'),save:text(card,'.save'),best:card.classList.contains('best'),mobile:card.classList.contains('mobile-click-card'),checkoutHost:safeHost(url),checkoutPath:safePath(url)};
  }
  function send(eventName,payload){
    var body = JSON.stringify({eventId:uuid(),sessionId:getSessionId(),pageSlug:pageSlug(),eventName:eventName,sourceUrl:location.href,referrer:document.referrer||null,utm:attribution(),payload:payload||{}});
    if(navigator.sendBeacon){ try { if(navigator.sendBeacon(ENDPOINT,new Blob([body],{type:'application/json'}))) return; } catch(_err){} }
    try { fetch(ENDPOINT,{method:'POST',headers:{'Content-Type':'application/json'},body:body,keepalive:true,mode:'cors'}).catch(function(){}); } catch(_err){}
  }
  function carryParams(url){
    var incoming = new URLSearchParams(location.search);
    ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','trybe','fbclid','gclid','preview_theme_id'].forEach(function(key){
      if(incoming.has(key)) url.searchParams.set(key,incoming.get(key));
    });
  }
  function addTrackingParams(rawUrl){
    if(!rawUrl) return rawUrl;
    try {
      var url = new URL(rawUrl, location.origin);
      var sessionId = getSessionId();
      var slug = pageSlug();
      carryParams(url);
      url.searchParams.set('prspr_offer_session',sessionId);
      url.searchParams.set('prspr_offer_page',slug);
      var redirect = url.searchParams.get('redirect');
      if(redirect){
        try {
          var redirectUrl = new URL(redirect,url.origin);
          carryParams(redirectUrl);
          redirectUrl.searchParams.set('prspr_offer_session',sessionId);
          redirectUrl.searchParams.set('prspr_offer_page',slug);
          url.searchParams.set('redirect',redirectUrl.pathname+redirectUrl.search+redirectUrl.hash);
        } catch(_err){}
      }
      return url.href;
    } catch(_err) { return rawUrl; }
  }
  function cardSummary(){ return Array.from(document.querySelectorAll('#offer .offer')).map(cardPayload); }
  function bindCardsViewed(){
    var offer=document.querySelector('#offer'); if(!offer||trackedCardsViewed) return;
    function fire(){ if(trackedCardsViewed) return; trackedCardsViewed=true; send('offer_cards_viewed',{cards:cardSummary()}); }
    if(!('IntersectionObserver' in window)){ setTimeout(fire,1200); return; }
    var observer=new IntersectionObserver(function(entries){ entries.forEach(function(entry){ if(entry.isIntersecting){ fire(); observer.disconnect(); } }); },{threshold:0.35});
    observer.observe(offer);
  }
  function bindDealClicks(){
    document.querySelectorAll('.offer .checkout-btn, .mobile-offer-stack .mobile-click-card').forEach(function(el){
      el.addEventListener('click',function(event){
        if(el.classList.contains('mobile-click-card')&&event.target.closest('a,button,input,label')) return;
        var card=el.closest('.offer')||el;
        var checkoutUrl=el.getAttribute('data-checkout-href')||el.getAttribute('data-card-checkout-href')||el.getAttribute('href')||'';
        send('offer_deal_clicked',cardPayload(card));
        if(safeHost(checkoutUrl)&&/prsprwellness\\.com$/i.test(safeHost(checkoutUrl))) send('offer_shopify_redirect',Object.assign(cardPayload(card),{checkoutPath:safePath(checkoutUrl)}));
        // Never rewrite Shopify discount/cart URLs in the click handler. The original
        // URL already carries the approved offer attribution. Re-encoding its nested
        // redirect query can drop variant/quantity parameters and return Cart Error 400.
      },true);
    });
  }
  function nativeSubmit(form){
    HTMLFormElement.prototype.submit.call(form);
  }
  function bindNativeCartForms(){
    document.querySelectorAll('form.prspr-cart-form').forEach(function(form){
      var button=form.querySelector('button[type="submit"]');
      if(button){
        button.addEventListener('click',function(event){
          if(button.getAttribute('aria-disabled')==='true') return;
          event.preventDefault();
          event.stopImmediatePropagation();
          nativeSubmit(form);
        },true);
      }
      form.addEventListener('submit',function(event){
        var submitter=event.submitter||button;
        if(submitter&&submitter.getAttribute('aria-disabled')==='true') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        nativeSubmit(form);
      },true);
    });
  }
  document.addEventListener('DOMContentLoaded',function(){ send('offer_page_view',{title:document.title,cards:cardSummary().length}); bindCardsViewed(); bindDealClicks(); bindNativeCartForms(); });
})();
